import { useRuntimeConfig } from "#app";
export function useColorHelpers() {
  const config = useRuntimeConfig();
  function getColorForRank(rank) {
    switch (rank) {
      case 1:
        return config.public.colors.gold;
      case 2:
        return config.public.colors.silver;
      case 3:
        return config.public.colors.bronze;
    }
    return void 0;
  }
  return {
    getColorForRank
  };
}
